/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { useEuiTour } from './useEuiTour';
import PropTypes from "prop-types";
export var EuiTour = ({
  children,
  steps,
  initialState
}) => {
  const [stepProps, actions, state] = useEuiTour(steps, initialState);
  return children(stepProps, actions, state);
};
EuiTour.propTypes = {
  children: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
  initialState: PropTypes.shape({
    currentTourStep: PropTypes.number.isRequired,
    isTourActive: PropTypes.bool.isRequired,
    tourPopoverWidth: PropTypes.number.isRequired,
    tourSubtitle: PropTypes.string.isRequired
  }).isRequired
};

try {
  // @ts-ignore
  EuiTour.displayName = "EuiTour"; // @ts-ignore

  EuiTour.__docgenInfo = {
    "description": "",
    "displayName": "EuiTour",
    "props": {
      "steps": {
        "defaultValue": null,
        "description": "",
        "name": "steps",
        "required": true,
        "type": {
          "name": "EuiStatelessTourStep[]"
        }
      },
      "initialState": {
        "defaultValue": null,
        "description": "",
        "name": "initialState",
        "required": true,
        "type": {
          "name": "EuiTourState"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/tour/tour.tsx#EuiTour"] = {
      docgenInfo: EuiTour.__docgenInfo,
      name: "EuiTour",
      path: "src/components/tour/tour.tsx#EuiTour"
    };
} catch (__react_docgen_typescript_loader_error) {}